import { Navigate, Outlet, useLocation } from 'react-router-dom'
import { useTranslation } from 'react-i18next'
import { useAuth } from '../../features/auth/state/useAuth'

export function RequireAuth() {
  const { t } = useTranslation()
  const location = useLocation()
  const auth = useAuth()

  if (auth.isLoading) {
    return (
      <div className="grid min-h-screen place-items-center bg-background px-4">
        <p className="text-sm text-muted-foreground">{t('auth.checkingSession')}</p>
      </div>
    )
  }

  if (!auth.isAuthenticated) {
    const from = `${location.pathname}${location.search}`
    return <Navigate to="/login" replace state={{ from }} />
  }

  return <Outlet />
}
